'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { IconPin, Clock, PinCheck } from '@/components/atoms/Icons';
import { getHeartVisitCount } from '@/shared/heartVisits';
import { trackHeartClick } from '@/lib/client/gtm';
import HeartSaveButton from '@/components/organisms/HeartSaveButton';
export default function HeartCard(t0) {
  const $ = _c(44);
  const {
    data,
    communityName,
    communityState,
    pageType
  } = t0;
  const visitCount = getHeartVisitCount(data);
  const router = useRouter();
  let t1;
  if ($[0] !== data?.id || $[1] !== data?.slug || $[2] !== data?.title || $[3] !== pageType) {
    t1 = () => {
      trackHeartClick({
        heartId: data?.id,
        heartName: data?.title,
        heartSlug: data?.slug,
        source: pageType ? `hearts_nearby_${pageType}` : "hearts_nearby"
      });
    };
    $[0] = data?.id;
    $[1] = data?.slug;
    $[2] = data?.title;
    $[3] = pageType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClick = t1;
  let t2;
  if ($[5] !== router) {
    t2 = e => {
      e.stopPropagation();
      e.preventDefault();
      router.push("/leaderboard");
    };
    $[5] = router;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleLeaderboardClick = t2;
  const T0 = Link;
  const t3 = `/hearts/${data?.slug}`;
  const t4 = "!block relative 2xl:w-[20.37vw] xl:w-[21.5vw] lg:w-[28.5vw] md:w-[40vw] w-[76vw] bg-white rounded-[18px] shadow-[-2.7px_2.7px_27px_rgba(0,0,0,0.06)]";
  const t5 = "relative aspect-[391/477] overflow-hidden rounded-t-[18px] bg-black";
  let t6;
  if ($[7] !== data?.imagesWithAltText?.[0] || $[8] !== data?.title) {
    t6 = data?.imagesWithAltText?.[0] && <Image src={data?.imagesWithAltText?.[0].src} alt={data?.imagesWithAltText?.[0].alt || data?.title || "Heart Image"} fill={true} className="object-cover" />;
    $[7] = data?.imagesWithAltText?.[0];
    $[8] = data?.title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = data?.id;
  const t9 = data?.name;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <div className="absolute top-3 right-3 z-10" onClick={_temp}><HeartSaveButton heartId={t8} heartName={t9} iconOnly={true} className="text-[13px] text-white gap-1 bg-black/30 backdrop-blur-sm rounded-full px-3 py-2 hover:bg-black/50 transition-colors" /></div>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = "absolute bottom-0 left-0 right-0 xl:px-6 px-5 py-5 flex justify-between items-end";
  const t12 = "w-full";
  const t13 = data?.title;
  let t14;
  if ($[14] !== t13) {
    t14 = <h3 className="xl:text-2xl md:text-xl text-lg lg:font-bold font-semibold text-white leading-[1em]">{t13}</h3>;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = "flex justify-between gap-2.5 mt-1";
  let t16;
  if ($[16] !== data?.artistName) {
    t16 = data?.artistName ? <p className="text-[#CBCBCB] xl:text-base md:text-sm text-[13px]">by {data?.artistName}</p> : null;
    $[16] = data?.artistName;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  const t17 = visitCount !== null && visitCount > 0 ? <button type="button" onClick={handleLeaderboardClick} className="flex items-start gap-1.5 mt-0.5 cursor-pointer transition"><span className="lg:text-sm text-xs text-[#CBCBCB] whitespace-nowrap">{visitCount.toLocaleString()} Visits</span><PinCheck className="text-[#B9B9B9] h-4.5  mt-0.25" /></button> : null;
  let t18;
  if ($[18] !== t16 || $[19] !== t17) {
    t18 = <div className={t15}>{t16}{t17}</div>;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== t14 || $[22] !== t18) {
    t19 = <div className={t11}><div className={t12}>{t14}{t18}</div></div>;
    $[21] = t14;
    $[22] = t18;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t10 || $[25] !== t19 || $[26] !== t6 || $[27] !== t7) {
    t20 = <div className={t5}>{t6}{t7}{t10}{t19}</div>;
    $[24] = t10;
    $[25] = t19;
    $[26] = t6;
    $[27] = t7;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== data || $[30] !== pageType) {
    t21 = data?.distanceMiles || data?.distanceMinutes ? <div className="flex items-start gap-2"><span className="flex xl:w-5.5 xl:h-5.5 md:w-5 w-4.5 md:h-5 h-4.5 items-center justify-center"><Clock className="text-[#BABABA] xl:w-4.5 w-4" /></span><span className="text-[#626262] xl:text-base md:text-sm text-[13px]">{pageType === "heart" ? `${data.distanceMiles} miles away` : `${data.distanceMinutes} min away`}</span></div> : null;
    $[29] = data;
    $[30] = pageType;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== communityName || $[33] !== communityState) {
    t22 = communityName && communityState ? <div className="flex items-start gap-2 mt-1"><span className="flex xl:w-5.5 xl:h-5.5 md:w-5 w-4.5 md:h-5 h-4.5 items-center justify-center"><IconPin className="text-[#BABABA] xl:h-4 h-3.5" /></span><span className="text-[#626262] xl:text-base md:text-sm text-[13px]">{communityName}, {communityState}</span></div> : null;
    $[32] = communityName;
    $[33] = communityState;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t21 || $[36] !== t22) {
    t23 = <div className="xl:px-6 px-5 md:py-4.5 py-3">{t21}{t22}</div>;
    $[35] = t21;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== T0 || $[39] !== handleClick || $[40] !== t20 || $[41] !== t23 || $[42] !== t3) {
    t24 = <T0 href={t3} onClick={handleClick} className={t4}>{t20}{t23}</T0>;
    $[38] = T0;
    $[39] = handleClick;
    $[40] = t20;
    $[41] = t23;
    $[42] = t3;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  return t24;
}
function _temp(e_0) {
  e_0.stopPropagation();
  e_0.preventDefault();
}